const CaloriesCell = ({ value }: { value: { isHidden: boolean; calories: number | null } }) => (
  <div className={`custom-cell-container ${value?.isHidden && 'hidden-cell-value'}`}>
    <span>{value.calories ?? '--'}</span>
  </div>
);

export default CaloriesCell;
